import { Col, Row, TabContent, TabPane } from "reactstrap";
import { SocialTabsContentProp } from "../../../../types/Applications";
import TimelineTab from "./timelineTab";
import { UserLists } from "../../../../data/applications/Users";
import Photos from "./Photos";
import About from "./about";
import UserCard from "../../../../coreComponents/UserCard";

const SocialTabsContent: React.FC<SocialTabsContentProp> = ({ activeTab }) => {
  return (
    <TabContent activeTab={activeTab} className="tab-content">
      <TabPane tabId={1}>
        <TimelineTab />
      </TabPane>
      <TabPane tabId={2}>
        <About />
      </TabPane>
      <TabPane tabId={3}>
        <Row>
          {UserLists.map((user) => (
            <Col sm="6" xxl="3" xl="4" className="box-col-4" key={user.id}>
              <UserCard user={user} />
            </Col>
          ))}
        </Row>
      </TabPane>
      <TabPane tabId={4}>
        <Row>
          <Photos />
        </Row>
      </TabPane>
    </TabContent>
  );
};

export default SocialTabsContent;
